import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { IComment } from 'app/components/CommonStyled/Comment';
import { getResourceMessages } from 'services/resources';

interface IResourceMessages {
  messages: IComment[];
  notifications_status: boolean;
}

export default function useResourceMessages(
  slug: string,
  options?: Omit<UseQueryOptions<IResourceMessages, Error, IResourceMessages, QueryKey>, 'queryKey'>
) {
  return useQuery<IResourceMessages, Error>(
    `resource-${slug}-messages`,
    () =>
      getResourceMessages(slug).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        if (response.status === 404) {
          throw new Error('Resource not found');
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 0,
      retry: false,
    }
  );
}
